<template>
  <div class="w-100">

    <div class="card mb-4">
      <div class="card-header pb-0">
        <h6>Detalle del agente</h6>
      </div>
      <div class="card-body px-4">
        <div class="row">
          <div class="col">
            <ul style="list-style: none" v-if="user">
              <li><span class="font-weight-bold">Nombre: </span><span>{{user.name}}</span></li>
              <li><span class="font-weight-bold">Correo electrónico: </span><span>{{user.email}}</span></li>
              <li><span class="font-weight-bold">Contraseña: </span><span>{{user.password_text}}</span></li>
              <li><span class="font-weight-bold">Porcentaje de comisión: </span>{{user.percentage * 100}}%<span></span></li>
              <li><span class="font-weight-bold">Estado: </span><span>{{user.status?'ACTIVO':'INACTIVO'}}</span></li>
              <li><span class="font-weight-bold">Fecha de registro: </span><span>{{$filters.formatDate(user.created_at)}}</span></li>
            </ul>
            <hr>

          </div>
          <div class="col">
            <div class="row">
              <div class="col">
                <label>Nombre</label>
                <input type="text" class="form-control" v-model="form.name">
                <label>Correo electrónico</label>
                <input type="text" class="form-control" v-model="form.email">
                <label>Porcentaje de comisión</label>
                <input type="number" class="form-control" v-model="form.percentage">
              </div>
              <div class="col">
                <label>Contraseña</label>
                <input type="text" class="form-control" v-model="form.password">
                <label>Teléfono</label>
                <input type="number" class="form-control" v-model="form.phone">
                <label>Rol</label>
                <select type="text" class="form-control" v-model="form.type">
                  <option value="agent_leads">Agente Leads</option>
                  <option value="agent_ftd">Agente FTD</option>
                  <option value="agent_retention">Agente Retencion</option>
                  <option value="supervisor_ftd">Supervisor FTD</option>
                  <option value="supervisor_retention">Supervisor Retencion</option>
                  <option value="administrator">Administrador del sistema</option>
                </select>
                <label>Estado</label>
                <select type="text" class="form-control" v-model="form.status">
                  <option value="true">ACTIVO</option>
                  <option value="false">INACTIVO</option>
                </select>
              </div>
              <button  class="btn bg-gradient-success mt-4 w-100" @click="copyUser"> Copiar datos del usuario</button>
              <button  class="btn bg-gradient-success w-100" @click="updateProfile"> Actualizar información del usuario</button>
            </div>
          </div>
          <div class="col text-center" v-if="user && show_avatar">
            <img v-if="user.url_avatar" :src="user.url_avatar" alt="..." class="img-thumbnail">
            <img v-else
                 style="max-width: 200px"
                 src="https://cdn-icons-png.flaticon.com/512/149/149071.png?w=826&t=st=1681779976~exp=1681780576~hmac=b62bef118355188308be83a13bd11e2887b7caffd786ec75d3c56a581d7fdd48"
                 class="img-thumbnail">
            <input type="file" class="form-control mt-2" @change="selectImage">
            <button  class="btn bg-gradient-success mt-4 w-100" @click="uploadAvatar"> Actualizar avatar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4" v-if="user && showIpSection">
      <div class="card-header pb-0">
        <h6>IP permitida para inicio de sesión</h6>
        <p class="text-xs text-secondary mb-0">
          <template v-if="user.type === 'administrator'">
            El administrador no se restringe por IP: aunque quede vacía, igual puede ingresar.
          </template>
          <template v-else>
            El agente solo podrá iniciar sesión desde esta IP.
            <strong>Si queda vacía, NO podrá ingresar.</strong>
          </template>
        </p>
      </div>
      <div class="card-body px-4">
        <input type="text" class="form-control" placeholder="Ej. 192.168.0.1" v-model="allowedIp">
        <button class="btn bg-gradient-success mt-3" @click="saveIp">Guardar IP</button>
      </div>
    </div>
  </div>

</template>

<script>

import {get, post} from "@/utils/httpRequest";
import uploadFile from "@/utils/uploadFile";
export default {
  name: "index",
  data: () => ({
    user_id: null,
    user: null,
    tabSelected: 'transactions',
    url_avatar: '',
    show_avatar: true,
    allowedIp: '',
    form: {
      name: '',
      email: '',
      percentage: 0,
      password: '',
      type: '',
      phone: '',
      status: true
    },

  }),
  mounted() {
    this.user_id = this.$route.query.id
    this.getProfile()
  },

  computed: {
    showIpSection(){
      const type = this.user?.type || ''
      return type.startsWith('agent_') || type.startsWith('supervisor_') || type === 'administrator'
    }
  },

  methods: {
    async getProfile(){
      const {data} = await get(`users/find-one?id=${this.user_id}`, null)
      this.user = data
      this.form.status = data.status
      this.form.type = data.type
      this.allowedIp = data.allowed_ip || ''
    },
    async saveIp(){
      // Vaciar la IP de un agente staff lo deja sin acceso. No lo bloqueamos
      // (puede ser intencional para sacarlo), pero avisamos sin vueltas.
      const willBlock = this.user?.type !== 'administrator' && !this.allowedIp.trim()
      this.$swal({
        html: willBlock
          ? 'Atención: sin IP asignada, este agente NO podrá iniciar sesión. ¿Guardar igual?'
          : '¿Estás seguro?',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: `No`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await post('users/assign-ip', {id: this.user_id, allowed_ip: this.allowedIp.trim()})
            await this.getProfile()
            this.$swal({
              html: 'Procesado con éxito',
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false,
            });
          } catch (e) {
            this.$swal({
              html: 'Ocurrió un error al guardar las IPs',
              icon: 'error',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false,
            });
          }
        }
      })
    },
    async selectImage(e){
      this.url_avatar = e.target.files[0]
    },
    async uploadAvatar(){
      if(this.url_avatar!== ''){
        uploadFile.upload('users/upload-avatar',{file: this.url_avatar, _id: this.user_id})
        this.show_avatar = false
        this.url_avatar = ''
        await this.getProfile()
        this.show_avatar = true
        this.$swal({
          html: 'Procesado con éxito',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    async updateProfile(){
      if(this.form.name !== '' && this.form.email !== '' && this.form.type !== '' && this.form.percentage !== 0 && this.form.password !== ''){
        this.$swal({
          html: '¿Estás seguro?',
          showCancelButton: true,
          confirmButtonText: 'Sí',
          cancelButtonText: `No`,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.form.percentage = Number((this.form.percentage/100).toFixed(2))
            await post('users/update', {...this.form, _id: this.user_id})
            await this.getProfile()
            this.form = {
              name: '',
              email: '',
              percentage: 0,
              password: '',
              type: '',
              phone: ''
            }
            this.$swal({
              html: 'Procesado con éxito',
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false,
            });
          }
        })
      }
    },
    copyUser(){
      this.form = {
        name: this.user.name,
        email: this.user.email,
        percentage: this.user.percentage * 100,
        password: this.user.password_text,
        type: this.user.type,
        phone: this.user.phone,
        status: this.user.status
      }
    }
  }
}
</script>

